<template>
    <div>
        <div class="quan-item">
            <div class="body">
                <div class="header">
                    -
                    <span>
                    {{ formatType(detail.base_type) }}
               </span>
                    -
                </div>
                <div class="price">
                    <span v-if="detail.discount_usage.type.condition===1" class="sum">{{ formatPrice(detail) }}</span>
                    <span v-else class="percent">{{ formatPrice(detail) }}</span>
                </div>
                <div class="tip">
                    {{formatProduct(detail)}}
                </div>
                <div class="line">

                </div>
                <div  @click="goToUsage(detail)" class="use">
                    {{detail.check_data&&detail.check_data.time_ok ? '立即使用':"未开始"}}
                </div>
                <div @click="goToUsage(detail)" class="title">
                    {{detail.title}}
                </div>
            </div>
            <div class="footer">
                <div class="time">
                    <span style="letter-spacing: 1px">有效期:</span>
                    <format-time :time="detail.start_time" format="Y-m-d"></format-time>
                    -
                    <format-time :time="detail.end_time" format="Y-m-d"></format-time>
                </div>
                <div class="rights">
                    最终解释权归本公司所有
                </div>
            </div>
        </div>
        <buy-dialog  @close="buy_show=false" :level="2" :buy="company.current" :show="buy_show"></buy-dialog>
    </div>
</template>

<script>
import FormatTime from "@/components/common/format-time.vue";
import {formatPrice,discount_type} from "./js/type";
import BuyDialog from "@/components/user/buy/buy-dialog.vue";
export default {
    props: ['detail'],
    components: {BuyDialog, FormatTime},
    data() {
        return {
            buy_show:false,
            company: {
                list: [],
                search:'',
                current: {net_id:''},
                index: -1,
            },
        }
    },
    methods: {
        formatPrice,
        goToUsage(){
            let detail=this.detail;
            if (detail.check_data&&detail.check_data.time_ok){
                this.buy_show=true;
            }
        },
        formatProduct(detail){
            let select=detail&&detail.discount_usage&&detail.discount_usage.auth.value;
            if (!select||!Array.isArray(select)||select.length!==1){
                return '全部产品可用';
            }
            let title=[];
            [{label:'订阅版',value:2},{label:'企业版',value:3}].map(v=>{
                if (select.indexOf(v.value)>-1) title.push(v.label);
            });
            return  ['仅限',title.pop(),'使用'].join('');
        },
        formatType(value) {
            let all = discount_type();
            for (let i = 0; i < all.length; i++) {
                if (value === all[i].value) return all[i]['label'];
            }
            return '通用券'
        }
    }
}

</script>
<style scoped lang="less">
.quan-item {
    width: 210px;
    user-select: none;
    box-sizing: border-box;
    padding: 5px;

    .body {
        margin: 0 8px;
        position: relative;
        z-index: 99;
        padding: 15px 10px;

        border-radius: 10px;
        background-image: linear-gradient(to bottom, #fefbe6 0%, #fde5bd 100%);

        .header {
            font-size: 12px;
            text-align: center;
            color: #f69c70;
        }

        .price {
            text-align: center;
            padding: 25px 0;
            .percent {
                font-weight: bold;
                position: relative;
                font-size: 40px;
                color: #f4723b;

                &::before {
                    content: '%';
                    display: block;
                    position: absolute;
                    top: 24px;
                    right: -20px;
                    font-size: 16px;
                }
            }
            .sum {
                font-weight: bold;
                position: relative;
                font-size: 40px;
                color: #f4723b;

                &::before {
                    content: '¥';
                    display: block;
                    position: absolute;
                    top: 24px;
                    left: -16px;
                    font-size: 16px;
                }
            }
        }

        .tip {
            text-align: center;
            font-size: 12px;
            color: #ffbe4a;
        }

        .line {
            position: relative;
            margin: 10px 10px;
            border-top: 2px dashed #f79664;

            &::before {
                position: absolute;
                content: ' ';
                left: -27px;
                width: 20px;
                height: 20px;
                top: -10px;
                display: block;
                border-radius: 20px;
                background-color: #ef622d;
            }

            &::after {
                position: absolute;
                content: ' ';
                right: -27px;
                width: 20px;
                height: 20px;
                top: -10px;
                display: block;
                border-radius: 20px;
                background-color: #ef622d;
            }
        }

        .title,.use {
            text-align: center;
            font-weight: 500;
            font-size: 16px;
            cursor: pointer;
            color: #f47842;
        }

        .title{
            padding-top: 5px;
            opacity: 0.8;
            font-size: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .footer {
        font-size: 12px;
        background-color: #ef622d;
        padding: 10px;
        position: relative;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        text-align: center;

        &::before {
            position: absolute;
            content: ' ';
            display: block;
            bottom: 40px;
            top: -110px;
            left: 0;
            right: 0;
            border-radius: 5px;
            background-color: #ef622d;
        }

        .time {
            letter-spacing: -1px;
            color: #ddd;
            font-size: 12px;
        }
        .rights{
            padding-top: 5px;
            color: #ddd;
        }
    }
}
</style>